require('../modules/es6.symbol');
require('../modules/es6.object.to-string');
module.exports = require('../modules/_core').Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/es6/symbol.js
// module id = 1679
// module chunks = 0